var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 124,
    viewBox: "0 0 69 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2447 34L18.8789 24.0161C19.5709 22.9968 20.3512 21.9774 21.0431 21L31.8789 31.7379C31.3195 32.478 30.76 33.232 30.2447 34Z",
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0481 86C12.1111 83.3221 11.3311 80.5805 10.7129 77.7922L23.6957 72.6834C24.1313 74.6494 24.6839 76.5815 25.3499 78.4672L13.0481 86ZM9.87887 73.5118C7.51213 59.0785 9.37199 44.1882 15.1888 31L26.8789 40.0669C23.9376 46.6533 22.4018 53.8955 22.3891 61.2385C22.385 64.0833 22.613 66.9227 23.0702 69.7224L9.87887 73.5118Z",
    fill: "url(#paint1_linear_0_1)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.8789 0.307368C66.881 0.107591 64.8831 0 62.8278 0C29.0649 0 0.878906 27.8458 0.878906 62.1921C0.878906 94.2025 25.1266 120.588 55.9142 124C2.97741 69.3072 42.2452 22.4211 68.8789 0.307368Z",
    fill: "white",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 32,
    y1: 27.4375,
    x2: 19,
    y2: 27.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 24,
    y1: 64.4375,
    x2: 9,
    y2: 63.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.193e314dff7294add39fa7f8c75b6639.svg";
export { ForwardRef as ReactComponent };